import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./Services.css";
import CategoriesNav from "../categoriesNav/categoriesNav";
import { fetchData } from "../../Api/dataApi";
import { Link } from "react-router-dom";

const Services = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { t } = useTranslation();

  const truncateText = (text, wordLimit) => {
    if (!text) return "";
    const words = text.split(" ");
    return words.length > wordLimit
      ? words.slice(0, wordLimit).join(" ") + "..."
      : text;
  };

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const result = await fetchData("Services");
        setData(result);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  return (
    <div className="Services">
      <CategoriesNav />
      <h2 className="Services-title">{t("available_services")}</h2>

      {loading && <p>{t("loading")}</p>}
      {error && (
        <p style={{ color: "red" }}>{t("error_message", { message: error })}</p>
      )}

      <div className="Services-container">
        {data.map((service) => (
          <div key={service.id || service._id} className="Services-card">
            <Link to={`/product/${service.id || service._id}`}>
              <img
                src={
                  Array.isArray(service.images) && service.images.length > 0
                    ? service.images[0]
                    : t("default_image")
                }
                alt={service.title || t("no_name")}
                className="Services-image"
              />
            </Link>
            <div className="Services-content">
              <h3 className="Service-name">
                {truncateText(service.title || t("no_name"), 6)}
              </h3>
              <p className="Service-description">
                {truncateText(service.description || t("no_description"), 6)}
              </p>
              <p className="Service-price">
                {t("price")}: {service.price || t("no_price")}
              </p>
              <p className="Service-location">
                {t("location")}: {service.location || t("no_location")}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Services;
